<template>
  <div class="container">
    <el-tabs v-model="activeName" class="tab-container">
      <el-tab-pane label="关联箱子" name="addBox"></el-tab-pane>
      <el-tab-pane label="扫描快递单" name="send"></el-tab-pane>
    </el-tabs>
    <tpProdAssociatedBox v-if="activeName === 'addBox'"/>
    <tpProdScanningExpress v-if="activeName === 'send'"/>
  </div>
</template>

<script>
import tpProdAssociatedBox from './components/tpProdAssociatedBox';
import tpProdScanningExpress from './components/tpProdScanningExpress';

export default {
  name: 'AppDeliver',
  components: {
    tpProdAssociatedBox,
    tpProdScanningExpress,
  },
  data() {
    return {
      activeName: 'addBox',
    };
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
  }
  .tab-container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    flex-direction: column;
  }
</style>
